import { Box, Heading } from '@hover/blueprint';
import React from 'react';

import type { UserBasicInfo } from 'src/shared/graphql/generated';

interface AvatarProps {
  user: UserBasicInfo;
}

const colorCombos = [
  ['neutral.200', 'neutral.600'],
  ['neutral.500', 'neutral.100'],
  ['neutral.100', 'neutral.600'],
  ['neutral.600', 'neutral.100'],
  ['neutral.200', 'neutral.700'],
  ['neutral.700', 'neutral.200'],
  ['neutral.200', 'neutral.500'],
  ['neutral.500', 'neutral.200'],
];

const Avatar: React.FC<AvatarProps> = ({ user }) => {
  /*
   * The goal is to eventually use this as a renderer for a user's avatar.
   * Until that is available on the User object, we'll only render initials.
   * The Box styling is ready to display the avatar image once it's available.
   *
   * The commented out code below is the code that will be used once the
   * avatar image is available.
   *
   * The type of the user prop will need to be changed to `User` once the
   * avatar image is available.
   *
   * TODO: joshbroton - 2023-10-11 - Update the component to show profilePictureUrl when it's available
   */

  const renderInitials = () => {
    let initials = '';

    if (user.firstName) {
      initials += user.firstName[0];
    }

    if (user.lastName) {
      initials += user.lastName[0];
    }

    if (initials === '') {
      initials += user.email[0];
    }

    return initials.toUpperCase();
  };

  return (
    <Box
      alignItems="center"
      background="50% 50% no-repeat / cover"
      backgroundColor={colorCombos[user.id % 8][0]}
      /* backgroundImage={
        user.profilePictureUrl ? `url(${user.profilePictureUrl})` : undefined
      } */
      borderRadius="50%"
      height={40}
      justifyContent="center"
      marginRight={10}
      width={40}
    >
      {/* {!user.profilePictureUrl && ( */}
      <Heading
        marginBottom={0}
        size={200}
        textColor={colorCombos[user.id % 8][1]}
      >
        {renderInitials()}
      </Heading>
      {/* )} */}
    </Box>
  );
};

export { Avatar };
